// extracted by mini-css-extract-plugin
module.exports = {"root":"NavbarMobile_root__TNr_K","control":"NavbarMobile_control__P3t3w","panel":"NavbarMobile_panel__Aq0UT","item":"NavbarMobile_item__4ca9j"};